/**
 * Every API endpoint path the permission model knows about.
 *
 * Ported verbatim from the legacy `src/core/enum/permission.enum.ts`. It is an `as const`
 * object rather than an `enum` (CLAUDE.md > TypeScript), so `EndpointPath` is the union of the
 * literal strings and a typo is a compile error rather than a silently ungated screen.
 *
 * A path on its own grants nothing. It is the KEY into `ENDPOINT_PERMISSIONS`, which maps it to
 * the permission NAME a session has to hold. See `endpoint-permissions.ts`.
 *
 * 272 entries. Generated from the legacy file; keep it sorted the way the legacy file
 * was so the two can still be diffed.
 */
export const ENDPOINT_PATHS = {
  AdminApiKeyPost: '/admin/api-key/post',
  AdminApiKeyPut: '/admin/api-key/put',
  AdminApiQuotaPost: '/admin/api-quota/post',
  AdminApiKeyManagerListPost: '/admin/apikey-manager/list/post',
  AdminBillingAdjustmentGet: '/admin/billing-adjustment/get',
  AdminBillingAdjustmentPost: '/admin/billing-adjustment/post',
  AdminBillingAdjustmentDelete: '/admin/billing-adjustment/delete',
  AdminBillingAdjustmentPaymentPost: '/admin/billing-adjustment-payment/post',
  AdminBillingAdjustmentUsersGet: '/admin/billing-adjustment-users/get',
  AdminClientCredentialsPost: '/admin/client-credentials/post',
  AdminClientCacheManageGetIpList: '/admin/client-cache-manage/get_ip_list',
  AdminClientCacheManageRemoveIpCache: '/admin/client-cache-manage/remove_ip_cache',
  AdminCustomerManagementCustomersGet: '/admin/customer-management/customers/get',
  AdminCustomerManagementMlsCustomerGet: '/admin/customer-management/mls-customers/get',
  AdminDiagnosticGet: '/admin/diagnostic/get',
  AdminEntitiesBttPermissionAdvantagesPost: '/admin/entities/btt_permission_advantages/post',
  AdminEntitiesBttTypeItemsPost: '/admin/entities/btt_type_items/post',
  AdminEntitiesFeedTypesConnectionTypesPost: '/admin/entities/feed_types_connection_types/post',
  AdminEntitiesGroupsPost: '/admin/entities/groups/post',
  AdminEntitiesInvoiceItemPackagesPost: '/admin/entities/invoice_item_packages/post',
  AdminEntitiesInvoicesPost: '/admin/entities/invoices/post',
  AdminEntitiesLanguagesPost: '/admin/entities/languages/post',
  AdminEntitiesLocationsPost: '/admin/entities/locations/post',
  AdminEntitiesPackageDescriptionsPost: '/admin/entities/package_descriptions/post',
  AdminEntitiesPackageBttItemsPost: '/admin/entities/package_btt_items/post',
  AdminEntitiesPackagesPreReqBttItemsPost: '/admin/entities/packages_pre_req_btt_items/post',
  AdminEntitiesPackagesPost: '/admin/entities/packages/post',
  AdminEntitiesPaymentMethodPost: '/admin/entities/payment_method/post',
  AdminEntitiesPromotionsPost: '/admin/entities/promotions/post',
  AdminEntitiesRolesPost: '/admin/entities/roles/post',
  AdminEntitiesStaffsPost: '/admin/entities/staffs/post',
  AdminEntitiesUsagePlansPost: '/admin/entities/usage_plans/post',
  AdminEntitiesUserProfessionsPost: '/admin/entities/user_professions/post',
  AdminEntitiesUsersPost: '/admin/entities/users/post',
  AdminPaymentPlanGpmsMAll: '/admin/paymentplan_gpms/*',
  AdminPaymentPlanGpmsGet: '/admin/paymentplan_gpms/get',
  AdminPaymentPlanGpmsPost: '/admin/paymentplan_gpms/post',
  AdminPaymentPlanGpmsDelete: '/admin/paymentplan_gpms/delete',
  AdminPaymentPlanGpmsPut: '/admin/paymentplan_gpms/put',
  AdminRotateClientIdPost: '/admin/rotate-client-id/post',
  AdminSystemCountryListGet: '/admin/system-country-list/get',
  AdminUsagePlansMAll: '/admin/usage_plans/*',
  AdminUsagePlansGet: '/admin/usage_plans/get',
  AdminUsagePlansPost: '/admin/usage_plans/post',
  AdminUsagePlansDelete: '/admin/usage_plans/delete',
  AdminUsagePlansPut: '/admin/usage_plans/put',
  BenTestPost: '/ben-test/post',
  BttAddEditPost: '/btt/add-edit/post',
  BttDeletePost: '/btt-delete/post',
  GroupBttPAllMAll: '/group/btt/*',
  GroupBttBttListGet: '/group/btt/btt_list/get',
  GroupBttGroupBttListGet: '/group/btt/group_btt_list/get',
  GroupBttManageBttPost: '/group/btt/manage_btt/post',
  GroupBttManageBttGet: '/group/btt/manage_btt/get',
  AdminPackagesBttItemsV2Get: '/admin/packages_btt_items_v2/get',
  AdminPackagesPreReqBttItemsV2Get: '/admin/packages_pre_req_btt_items_v2/get',
  GroupJoinApprovementPAllMAll: '/group/join-approvement/*',
  GroupJoinApprovementJoinApprovementPost: '/group/join-approvement/join-approvement/post',
  GroupJoinApprovementJoinListGet: '/group/join-approvement/join-list/get',
  GroupManagePAllMAll: '/group/manage/*',
  GroupManageAddDocumentPatch: '/group/manage/add_document/patch',
  GroupManageAddLinkPatch: '/group/manage/add_link/patch',
  GroupManageBasicInfoPatch: '/group/manage/basic_info/patch',
  GroupManageCreatePost: '/group/manage/create/post',
  GroupManageExpertiseAreaActivityPatch: '/group/manage/expertise_area_activity/patch',
  GroupManageGroupTypePatch: '/group/manage/group_type/patch',
  GroupManageItemGet: '/group/manage/item/get',
  GroupManageListGet: '/group/manage/list/get',
  GroupManageModifyDocumentPatch: '/group/manage/modify_document/patch',
  GroupManageModifyLinkPatch: '/group/manage/modify_link/patch',
  GroupManageRemoveDocumentPatch: '/group/manage/remove_document/patch',
  GroupManageRemoveLinkPatch: '/group/manage/remove_link/patch',
  GroupManageUniqueFieldGet: '/group/manage/unique_field/get',
  GroupMemberPAllMAll: '/group/member/*',
  GroupMemberListGet: '/group/member/list/get',
  GroupMemberRolePatch: '/group/member/role/patch',
  GroupWhiteListPAllMAll: '/group/whitelist/*',
  GroupWhiteListListGet: '/group/whitelist/list/get',
  GroupWhiteListListPost: '/group/whitelist/list/post',
  GroupWhiteListRemoveDelete: '/group/whitelist/remove/delete',
  JaydenFirstPost: '/jayden/first/post',
  MembershipAdminDiscountsPost: '/membership/admin/discounts/post',
  MembershipAdminDiscountsDelete: '/membership/admin/discounts/delete',
  MembershipAdminDiscountsPut: '/membership/admin/discounts/put',
  MembershipAdminDiscountsGet: '/membership/admin/discounts/get',
  MembershipAdminPackagesV2MAll: '/membership/admin/packages_v2/*',
  MembershipAdminPackagesV2Get: '/membership/admin/packages_v2/get',
  MembershipAdminPackagesV2Post: '/membership/admin/packages_v2/post',
  MembershipAdminPackagesV2Put: '/membership/admin/packages_v2/put',
  MembershipAdminPackagesV2Delete: '/membership/admin/packages_v2/delete',
  MembershipAdminPackagesDelete: '/membership/admin/packages/delete',
  MembershipAdminPackagesPost: '/membership/admin/packages/post',
  MembershipAdminPackagesPut: '/membership/admin/packages/put',
  MembershipAdminPackagesGet: '/membership/admin/packages/get',
  MembershipAdminPaymentMethodsPost: '/membership/admin/payment-methods/post',
  MembershipAdminPaymentMethodsPut: '/membership/admin/payment-methods/put',
  MembershipAdminPromossionsPost: '/membership/admin/promossions/post',
  MembershipAdminPromossionsPut: '/membership/admin/promossions/put',
  MembershipAdminPromossionsDelete: '/membership/admin/promossions/delete',
  MembershipMlsServersGet: '/membership/mls-servers/get',
  MembershipPaymentPlanMlsDataMAll: '/membership/paymentplan_mlsdata/*',
  MembershipPaymentPlanMlsDataGet: '/membership/paymentplan_mlsdata/get',
  MembershipPaymentPlanMlsDataPost: '/membership/paymentplan_mlsdata/post',
  MembershipPaymentPlanMlsDataPut: '/membership/paymentplan_mlsdata/put',
  MembershipUserActiveServicesGet: '/membership/admin/user-active-services/get',
  MultiLanguageDictionariesPut: '/multilanguage/dictionaries/put',
  MultiLanguageDictionariesGet: '/multilanguage/dictionaries/get',
  AgreementTemplateGet: '/agreement/template/get',
  AgreementSignedGet: '/agreement/log/get',
  DealCompletedAdminGet: '/negotiator-tm/dashboard/deal/admin/deals/get',
  MultiLanguageDictionariesDelete: '/multilanguage/dictionaries/delete',
  MultiLanguageDictionariesPAllPut: '/multilanguage/dictionaries',
  MultiLanguageDictionariesAll: '/multilanguage/dictionaries/add',
  MultiLanguageDictionariesAddPost: '/multilanguage/dictionaries/add/post',
  MultiLanguageDictionariesDeleteDraftDelete: '/multilanguage/dictionaries/delete_draft/delete',
  MultiLanguageDictionariesDeletePublishedDelete:
    '/multilanguage/dictionaries/delete_published/delete',
  MultiLanguageDictionariesEditPut: '/multilanguage/dictionaries/edit/put',
  MultiLanguageDictionariesPublishPut: '/multilanguage/dictionaries/publish/put',
  NegotiatorApiV1PAllMAll: '/negotiator/api/v1/*',
  NotificationsAdminTemplatePost: '/notifications/admin/template/post',
  NotificationsActionsMAll: '/notifications/actions/*',
  NotificationsActionsGet: '/notifications/actions/get',
  NotificationsActionsPAllGet: '/notifications/actions',
  NotificationsActionsPAllPut: '/notifications/actions/put',
  NotificationsActionsBulkPost: '/notifications/actions/bulk/post',
  NotificationsActionsPost: '/notifications/actions/post',
  NotificationsActionsPAllPatch: '/notifications/actions/patch',
  NotificationsActionsPAllDelete: '/notifications/actions/delete',
  NotificationsApplicationGet: '/notifications/application/get',
  NotificationsApplicationPost: '/notifications/application/post',
  NotificationsApplicationPAllMAll: '/notifications/application/*',
  NotificationsCategoriesGet: '/notifications/categories/get',
  NotificationsCategoriesPost: '/notifications/categories/post',
  NotificationsCategoriesBulkPost: '/notifications/categories/bulk/post',
  NotificationsCategoriesPAllPut: '/notifications/categories/put',
  NotificationsCategoriesPAllPatch: '/notifications/categories/patch',
  NotificationsCategoriesPAllDelete: '/notifications/categories/delete',
  NotificationsCategoriesPAllGet: '/notifications/categories',
  NotificationsMessagesGet: '/notifications/messages/get',
  NotificationsMessagesPAllGet: '/notifications/messages',
  NotificationsMessagesPost: '/notifications/messages/post',
  NotificationsMessagesBulkPost: '/notifications/messages/bulk/post',
  NotificationsMessagesPAllPut: '/notifications/messages/put',
  NotificationsMessagesPAllPatch: '/notifications/messages/patch',
  NotificationsMessagesPAllDelete: '/notifications/messages/delete',
  NotificationsNestedGet: '/notifications/nested/get',
  NotificationsNestedPAllGet: '/notifications/nested',
  NotificationsSettingsPAllPut: '/notifications/settings/put',
  NotificationsSettingsPAllDelete: '/notifications/settings/delete',
  NotificationsSettingsPost: '/notifications/settings/post',
  NotificationsSettingsGet: '/notifications/settings/get',
  NotificationsSettingsPAllGet: '/notifications/settings',
  NotificationsSettingsPAllPatch: '/notifications/settings/patch',
  NotificationsSettingsPAllMAll: '/notifications/settings/*',
  NotificationsSettingsBulkPost: '/notifications/settings/bulk/post',
  NotificationsSettingsListGet: '/notifications/settings/list/get',
  NotificationsSettingsListPAllGet: '/notifications/settings/list',
  NotificationsTemplateGet: '/notifications/template/get',
  NotificationsTemplateDelete: '/notifications/template/delete',
  NotificationsTemplatePut: '/notifications/template/put',
  NotificationsTemplatePAllMAll: '/notifications/template/*',
  NotificationsTemplateBulkPost: '/notifications/template/bulk/post',
  NotificationsTokenMAll: '/notifications/token/*',
  NotificationsVariablesPAllGet: '/notifications/variables/get',
  NotificationsVariablesGet: '/notifications/variables',
  NotificationsVariablesPost: '/notifications/variables/post',
  NotificationsVariablesBulkPost: '/notifications/variables/bulk/post',
  NotificationsVariablesPAllPut: '/notifications/variables/put',
  NotificationsVariablesPAllPatch: '/notifications/variables/patch',
  NotificationsVariablesPAllDelete: '/notifications/variables/delete',
  NotificationsCodesPAllGet: '/notifications/codes/get',
  NotificationsCodesGet: '/notifications/codes',
  NotificationsCodesBulkPost: '/notifications/codes/bulk/post',
  NotificationsCodesPost: '/notifications/codes/post',
  NotificationsCodesPAllPut: '/notifications/codes/put',
  NotificationsCodesPAllPatch: '/notifications/codes/patch',
  NotificationsCodesPAllDelete: '/notifications/codes/delete',
  NotificationsMicroservicesPAllGet: '/notifications/microservices',
  NotificationsMicroservicesGet: '/notifications/microservices/get',
  NotificationsMicroservicesBulkPost: '/notifications/microservices/bulk/post',
  NotificationsMicroservicesPost: '/notifications/microservices/post',
  NotificationsMicroservicesPAllPut: '/notifications/microservices/put',
  NotificationsMicroservicesPAllPatch: '/notifications/microservices/patch',
  NotificationsMicroservicesPAllDelete: '/notifications/microservices/delete',
  NotificationsApplicationsPAllGet: '/notifications/applications',
  NotificationsApplicationsGet: '/notifications/applications/get',
  NotificationsApplicationsPost: '/notifications/applications/post',
  NotificationsApplicationsBulkPost: '/notifications/applications/bulk/post',
  NotificationsApplicationsPAllPut: '/notifications/applications/put',
  NotificationsApplicationsPAllPatch: '/notifications/applications/patch',
  NotificationsApplicationsPAllDelete: '/notifications/applications/delete',
  NotificationsApplicationsMicroservicesTemplatesPAllGet:
    '/notifications/applications/microservices/templates',
  NotificationsApplicationsMicroservicesTemplatesGet:
    '/notifications/applications/microservices/templates/get',
  NotificationsApplicationsMicroservicesTemplatesPost:
    '/notifications/applications/microservices/templates/post',
  NotificationsApplicationsMicroservicesTemplatesBulkPost:
    '/notifications/applications/microservices/templates/bulk/post',
  NotificationsApplicationsMicroservicesTemplatesPAllPut:
    '/notifications/applications/microservices/templates/put',
  NotificationsApplicationsMicroservicesTemplatesPAllDelete:
    '/notifications/applications/microservices/templates/delete',
  NotificationsApplicationsMicroservicesTemplatesPAllPatch:
    '/notifications/applications/microservices/templates/patch',
  NotificationsVariablesPAllMAll: '/notifications/variables/*',
  PermissionAddPost: '/permission/add/post',
  PermissionAssignPost: '/permission/assign/post',
  PermissionDeletePost: '/permission/delete/post',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestPut:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request/put',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestGet:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request/get',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestDocumentMAll:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request_document/*',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestDocumentGet:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request_document/get',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestDocumentPost:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request_document/post',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestDocumentPut:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request_document/put',
  ProvidersMlsMlsAccessCustomerRequestsMlsAccessCustomerRequestDocumentDelete:
    '/providers/mls/mls-access-customer-requests/mls_access_customer_request_document/delete',
  ProvidersMlsMlsServersMlsAccessPost: '/providers/mls/mls-servers/mls_access/post',
  ProvidersMlsMlsServersMlsAccessPut: '/providers/mls/mls-servers/mls_access/put',
  ProvidersMlsMlsServersMlsAccessGet: '/providers/mls/mls-servers/mls_access/get',
  ProvidersMlsMlsServersMlsAccessDelete: '/providers/mls/mls-servers/mls_access/delete',
  ProvidersMlsMlsServersMlsAccessCredentialGet:
    '/providers/mls/mls-servers/mls_access_credential/get',
  ProvidersMlsMlsServersMlsAccessCredentialPost:
    '/providers/mls/mls-servers/mls_access_credential/post',
  ProvidersMlsMlsServersMlsAccessCredentialPut:
    '/providers/mls/mls-servers/mls_access_credential/put',
  ProvidersMlsMlsServersMlsAccessCredentialDelete:
    '/providers/mls/mls-servers/mls_access_credential/delete',
  ProvidersMlsMlsServersMlsAccessPaymenMethodPost:
    '/providers/mls/mls-servers/mls_access_paymen_method/post',
  ProvidersMlsMlsServersMlsAccessPaymenMethodPut:
    '/providers/mls/mls-servers/mls_access_paymen_method/put',
  ProvidersMlsMlsServersMlsAccessPaymenMethodGet:
    '/providers/mls/mls-servers/mls_access_paymen_method/get',
  ProvidersMlsMlsServersMlsAccessPaymenMethodDelete:
    '/providers/mls/mls-servers/mls_access_paymen_method/delete',
  ProvidersMlsMlsServersMlsAccessPaymenMethodFlatRateItemPut:
    '/providers/mls/mls-servers/mls_access_paymen_method_flat_rate_item/put',
  ProvidersMlsMlsServersMlsAccessPaymenMethodFlatRateItemGet:
    '/providers/mls/mls-servers/mls_access_paymen_method_flat_rate_item/get',
  ProvidersMlsMlsServersMlsAccessPaymenMethodFlatRateItemDelete:
    '/providers/mls/mls-servers/mls_access_paymen_method_flat_rate_item/delete',
  ProvidersMlsMlsServersMlsAccessPaymenMethodFlatRateItemPost:
    '/providers/mls/mls-servers/mls_access_paymen_method_flat_rate_item/post',
  ProvidersMlsMlsServersMlsAccessPaymenMethodRangeRateItemPut:
    '/providers/mls/mls-servers/mls_access_paymen_method_range_rate_item/put',
  ProvidersMlsMlsServersMlsAccessPaymenMethodRangeRateItemGet:
    '/providers/mls/mls-servers/mls_access_paymen_method_range_rate_item/get',
  ProvidersMlsMlsServersMlsAccessPaymenMethodRangeRateItemDelete:
    '/providers/mls/mls-servers/mls_access_paymen_method_range_rate_item/delete',
  ProvidersMlsMlsServersMlsAccessPaymenMethodRangeRateItemPost:
    '/providers/mls/mls-servers/mls_access_paymen_method_range_rate_item/post',
  ProvidersMlsMlsServersMlsConfigPost: '/providers/mls/mls-servers/mls_config/post',
  ProvidersMlsMlsServersMlsConfigPut: '/providers/mls/mls-servers/mls_config/put',
  ProvidersMlsMlsServersMlsConfigGet: '/providers/mls/mls-servers/mls_config/get',
  ProvidersMlsMlsServersMlsConfigDelete: '/providers/mls/mls-servers/mls_config/delete',
  ProvidersMlsMlsServersMlsDocumentPost: '/providers/mls/mls-servers/mls_document/post',
  ProvidersMlsMlsServersMlsDocumentPut: '/providers/mls/mls-servers/mls_document/put',
  ProvidersMlsMlsServersMlsDocumentGet: '/providers/mls/mls-servers/mls_document/get',
  ProvidersMlsMlsServersMlsDocumentDelete: '/providers/mls/mls-servers/mls_document/delete',
  ProvidersMlsMlsServersMlsServerPost: '/providers/mls/mls-servers/mls_server/post',
  ProvidersMlsMlsServersMlsServerPut: '/providers/mls/mls-servers/mls_server/put',
  ProvidersMlsMlsServersMlsServerGet: '/providers/mls/mls-servers/mls_server/get',
  ProvidersMlsMlsServersMlsServerDelete: '/providers/mls/mls-servers/mls_server/delete',
  ProvidersPlatformsMlsAccessCredentialPut: '/providers/platforms/mls_access_credential/put',
  ProvidersPlatformsMlsAccessCredentialPost: '/providers/platforms/mls_access_credential/post',
  ProvidersPlatformsMlsAccessCredentialGet: '/providers/platforms/mls_access_credential/get',
  ProvidersPlatformsMlsAccessCredentialDelete: '/providers/platforms/mls_access_credential/delete',
  ProvidersPlatformsPlatformPut: '/providers/platforms/platform/put',
  ProvidersPlatformsPlatformPost: '/providers/platforms/platform/post',
  ProvidersPlatformsPlatformGet: '/providers/platforms/platform/get',
  ProvidersPlatformsPlatformDelete: '/providers/platforms/platform/delete',
  ProvidersPlatformsPlatformCredentialPut: '/providers/platforms/platform_credential/put',
  ProvidersPlatformsPlatformCredentialPost: '/providers/platforms/platform_credential/post',
  ProvidersPlatformsPlatformCredentialGet: '/providers/platforms/platform_credential/get',
  ProvidersPlatformsPlatformCredentialDelete: '/providers/platforms/platform_credential/delete',
  RfBackendAddStaffPost: '/rf-backend/add-staff/post',
  RfBackendAssignRolePost: '/rf-backend/assign-role/post',
  RfBackendProfileDetailsGet: '/rf-backend/profile-details/get',
  RfBackendProfileSetupPost: '/rf-backend/profile-setup/post',
  UsagePlansListGet: '/usage_plans_list/get',
  UserActivatePost: '/user/activate/post',
  UserdeactivatePost: '/user/deactivate/post',
  RfBackendSignUpPost: '/rf-backend/signup/post',
  RfBackendAuthorizationPost: '/rf-backend/authorization/post',
  UploaderPost: '/uploader/post',
  MembershipAdminPaymentMethodsV2Post: '/membership/admin/payment-methods-v2/post',
  ProfileSetupProfessionsListGet: '/profile-setup/professions-list/get',
  ProfileSetupProfileDetailsGet: '/profile-setup/profile-details/get',
  SuggestionHashtagNormalPost: '/suggestion/hashtag/normal/post',
  LocationSuggestGet: '/location/suggest/get',
  LocationGetGet: '/location/get/get',
  LocationZipcodePost: '/location/zipcode/post',
  NegotiatorDeals: '/negotiator-tm/dashboard/deal/agent/deals/',
  ResourcesGet: '/admin/usage-plan-resources/get',
} as const;

export type EndpointPathKey = keyof typeof ENDPOINT_PATHS;
export type EndpointPath = (typeof ENDPOINT_PATHS)[EndpointPathKey];
